import { populateObjectUID } from "../utils/index.js";
export const PROPULSION_01 = populateObjectUID({
    name: ["2x Volvo Penta V8", "gasoline 6.2l 430hp"],
    description: ["with Z-drive", "(860hp combined)"],
});
export const PROPULSION_02 = populateObjectUID({
    name: ["2x Volvo Penta D6", "diesel 5.5l 440hp"],
    description: ["incl. aquamatic duo-prop drive", "(880hp combined) + Gen Set"],
});
export const PROPULSION_03 = populateObjectUID({
    name: ["300kW Full Electric", "(560kW peak)"],
    description: ["including battery + 150kW", "Range Extender"],
});
export const PROPULSION_04 = populateObjectUID({
    name: ["2x Volvo Penta V8", "430 CE DPS 6.2L 430hp"],
    description: ["incl. Aquamatic duo-prop drive", "(860hp combined)"],
});
export const PROPULSION_05 = populateObjectUID({
    name: ["2x Volvo Penta D4", "Diesel DPI 3.7L 320hp"],
    description: ["incl. Aquamatic duo-prop drive", "(640hp combined)"],
});
export const PROPULSION_06 = populateObjectUID({
    name: ["2x Volvo Penta V6", "280 CE DPS 280hp"],
    description: ["incl. Aquamatic duo-prop drive", "(560hp combined)"],
});
export const PROPULSION_07 = populateObjectUID({
    name: ["2x Volvo Penta D6", "diesel 5.5l 480hp"],
    description: ["incl. Aquamatic duo-prop drive", "(960hp combined) + Gen Set"],
});
export const PROPULSION_08 = populateObjectUID({
    name: ["2x Yanmar 8LV370", ""],
    description: ["", "(740hp combined)"],
});
export const PROPULSION_09 = populateObjectUID({
    name: ["1x Volvo Penta V8", "430 CE DPS 6.2L 430hp"],
    description: ["incl. Aquamatic duo-prop drive", "(321kW)"],
});
